const economyColors = {
  ECONOMY_50: '#FCE4EE',
  ECONOMY_100: '#F8BBD5',
  ECONOMY_200: '#F48EB8',
  ECONOMY_600: '#DC006A',
}

export default economyColors
